export interface LocationService {
  getUrl(): string;
  getSearchParams(): URLSearchParams;
  getDomain(): string;
}

export class BrowserLocationService implements LocationService {
  getUrl(): string {
    return window.location.href;
  }

  getSearchParams(): URLSearchParams {
    return new URLSearchParams(window.location.search);
  }

  getDomain(): string {
    return window.location.hostname;
  }
}
